import get from '@/api/base/with-authorization/get';
/**
 * Fetch an organisation.
 *
 * @returns {Promise}
 */
export default function () {
    return get('organisation/');
}
